import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Job } from '~hooks/useJob/models';
import { Ticket } from '~hooks/useTickets/models';

interface DriverAndTruckColumnProps {
  job?: Job;
  sx?: SxProps<Theme>;
  ticket?: Ticket;
}

export default function DriverAndTruckColumn({
  job,
  sx,
  ticket,
}: DriverAndTruckColumnProps) {
  const driverName = ticket?.driverName ?? job?.driverFullName;
  const equipmentName = ticket?.equipmentName ?? job?.equipment?.name;

  return (
    <Box sx={sx}>
      <OverflowAwareText sx={{ fontWeight: 600 }}>{driverName ?? '-'}</OverflowAwareText>

      <OverflowAwareText sx={(theme) => ({ color: theme.brandV2.colors.treadGray2 })}>
        {equipmentName ?? '-'}
      </OverflowAwareText>
    </Box>
  );
}
